<template>
  <v-row style="margin-top: 11px;" no-gutters class="search">
    <v-col cols="12" sm="5" class="pl-2">
      <v-menu
        ref="menu1"
        v-model="menu1"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            readonly
            v-model="computedDaFormatted"
            label="Anno/mese da"
            persistent-hint
            prepend-icon="mdi-calendar"
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          :color="colors.primarycolor"
          v-model="da"
          type="month"
          no-title
          @input="menu1 = false"
        ></v-date-picker>
      </v-menu>
    </v-col>
    <v-col cols="11" sm="5" offset-sm="1" class="pr-2">
      <v-menu
        ref="menu2"
        v-model="menu2"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            readonly
            v-model="computedAFormatted"
            label="Anno/mese a"
            persistent-hint
            prepend-icon="mdi-calendar"
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          :color="colors.primarycolor"
          v-model="a"
          type="month"
          no-title
          @input="menu2 = false"
        ></v-date-picker>
      </v-menu>
    </v-col>
    <v-col cols="1">
      <v-icon style="cursor: pointer" @click="$emit('search', da, a)"
        >mdi-magnify</v-icon
      >
    </v-col>
  </v-row>
</template>

<script>
import mixin from "@/mixin";

export default {
  name: "search-bar",
  mixins: [mixin],
  data: () => ({
    da: null,
    a: null,
    menu1: false,
    menu2: false,
  }),
    computed: {
      computedDaFormatted () {
        return this.formatDate(this.da)
      },
      computedAFormatted () {
        return this.formatDate(this.a)
      },
    },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month] = date.split("-");
      return `${month}/${year}`;
    },
  },
};
</script>

<style>

.search .v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.search .v-input input {
  width: 100px;
  font-size: 0.8em;
}

</style>